import { computed, action, observable } from 'mobx';
import { StoreBase } from '../../../common/StoreBase';
import { IDropdownConfiguration, IDropdownEntityItem } from '../models';
import { IDropdownProps } from '@kurtosys/ksys-app-components/dist/components/base/Dropdown/models';
import { utils } from '@kurtosys/ksys-app-template';

export class DropdownStore extends StoreBase {
	static componentKey: 'dropdown' = 'dropdown';

	@observable.ref items: IDropdownEntityItem[] = [];
	@observable.ref selectedItem: IDropdownEntityItem | undefined;

	@computed
	get configuration(): IDropdownConfiguration | undefined {
		if (this.storeContext && this.storeContext.appStore) {
			return this.storeContext.appStore.getComponentConfiguration(DropdownStore.componentKey);
		}
	}

	@action
	onChange(item: any) {
		const { appStore } = this.storeContext;
		appStore.redirect(item.linkedEntity);
	}

	@computed
	get props(): IDropdownProps {
		const props: IDropdownProps = {
			items: this.items,
			selectedItem: this.selectedItem,
			onChange: this.onChange.bind(this),
			singleItemDisplayOnly: true,
		};

		if (this.configuration && this.configuration.label) {
			props.label = this.configuration.label;
		}

		if (this.configuration && this.configuration.placeholder) {
			props.placeholder = this.configuration.placeholder;
		}

		if (this.configuration && !utils.typeChecks.isNullOrUndefined(this.configuration.singleItemDisplayOnly)) {
			props.singleItemDisplayOnly = this.configuration.singleItemDisplayOnly;
		}
		props.hide = (this.configuration && this.configuration.hideIfEmpty && this.items.length === 0);
		return props;
	}

	@action
	async initialize(): Promise<void> {
		await this.updateShareClasses();
	}

	@action
	async updateShareClasses() {
		const { queryStore, appStore } = this.storeContext;

		if (this.configuration) {
			const { dataEntitiesId, resultItemLabel, selectedInputKey } = this.configuration;
			const searchResponse = await queryStore.entitiesRequest(dataEntitiesId, { term: '' });
			if (searchResponse && searchResponse.total > 0) {
				const clientCode = appStore.getInput(selectedInputKey || 'isin');
				this.items = searchResponse.values.map((entity) => {
					const item = {
						value: entity.clientCode,
						label: this.getQueryValue(resultItemLabel, undefined, appStore.overrideEntityContext(entity)),
						linkedEntity: entity,
					};
					if (entity.clientCode === clientCode) {
						this.selectedItem = item;
					}
					return item;
				});
			}
		}
	}
}